import React from 'react'

interface AskAnythingResultDisplayProps {
  result: { [key: string]: any }
  keyClassname?: string
}

export const AskAnythingResultDisplay: React.FC<AskAnythingResultDisplayProps> = ({ result, keyClassname }) => {
  const renderValue = (value: any) => {
    if (typeof value === 'object' && value !== null) {
      return Array.isArray(value) ? (
        <ul>
          {value.map((item, index) => (
            <li key={index}>{renderValue(item)}</li>
          ))}
        </ul>
      ) : (
        <AskAnythingResultDisplay result={value} keyClassname='ms-1' />
      )
    } else {
      return <span>{String(value)}</span>
    }
  }

  return (
    <div>
      {Object.entries(result)
        .filter(([_, value]) => !!value)
        .map(([key, value]) => (
          <div key={key} className={keyClassname}>
            <strong>{key}:</strong> {renderValue(value)}
          </div>
        ))}
    </div>
  )
}
